import { ReactComponent as PersonSvgImported } from 'assets/icons/person.svg';
import styled from 'styled-components';
import colors from 'styles/colors';
import { ReactComponent as IllustrationImp } from 'assets/illustrations/illustration.svg';

export const Illustration = styled(IllustrationImp)`
  position: absolute;
  right: -84px;
  bottom: -30px;
  width: 274px;
  height: 184px;

  @media (max-width: 480px) {
    display: none;
  }

  @media (max-width: 1280px) {
    scale: 0.6;
    right: -104px;
    bottom: -30px;
  }
  @media (max-width: 1024px) {
    scale: 1;
  }
`;

export const PreCallWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.div`
  width: 100%;
  min-height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: ${colors.blue['500']};
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 28px;
  flex: 1;
  padding: 80px 20px 57px 20px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 8px;
    padding: 60px 20px 57px 20px;
  }
`;

export const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 33px;
  box-shadow: 0 4px 20px 0 rgba(0, 34, 122, 0.12);
  font-size: 12px;
  background: #ffffff;
  border-top: 1px solid #e6e5ec;
  width: 100%;

  a {
    color: ${colors.blue['950']};
    text-decoration: none;
  }

  > div {
    position: absolute;
    right: 16px;
  }
`;

export const Center = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  max-width: 1240px;
  align-items: center;
  margin-bottom: 125px;

  @media (max-width: 1024px) {
    margin-bottom: 0;
  }
`;

export const VideoWithControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 2;
`;

export const DeviceSelection = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const VideoWrapper = styled.div<{ $isVideoBlurred: boolean }>`
  position: relative;
  width: 100%;
  height: 420px;
  overflow: hidden;
  border-radius: 16px;

  /* Vonage video elements */
  .OT_root {
    width: 100% !important;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
  }

  .OT_video-element {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  video,
  canvas {
    height: 100%;
    width: 100%;
    background: black;
    object-fit: cover;
    position: absolute;
  }
  canvas {
    ${({ $isVideoBlurred }) => !$isVideoBlurred && 'opacity:0'}
  }
`;

export const PersonSvg = styled(PersonSvgImported)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Controls = styled.div`
  display: flex;
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  height: 62px;
  background: rgba(10, 10, 15, 0.54);
  border-radius: 12px;
  z-index: 10;

  @media (max-width: 480px) {
    width: 130px;
    margin: 0 auto;
    border-radius: 200px;
  }

  button {
    width: 48px;
    height: 48px;
    border: none;
    outline: none;
    cursor: pointer;

    svg {
      path,
      circle {
        transition: all 0.1s ease-in-out;
      }
    }

    &:hover {
      svg {
        path,
        circle {
          fill: ${colors.grey['200']};
        }
      }
    }
  }
`;

export const Left = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: 480px) {
    display: none;
  }
`;

export const Middle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  gap: 12px;
`;

export const Right = styled.div<{ $isVideoBlurred: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  button {
    margin-right: 12px;
    background: transparent;
    border-radius: 1200px;
    ${({ $isVideoBlurred }) => $isVideoBlurred && 'background: rgba(255, 255, 255, 0.2);'}
    &:focus-visible {
      outline: 2px solid #005fcc;
      outline-offset: 2px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &:active {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  @media (max-width: 480px) {
    display: none;
  }

  @media (max-width: 480px) {
    button {
      display: none;
    }
  }
`;

export const ToggleButton = styled.button<{ $muted: boolean }>`
  background: ${({ $muted }) => ($muted ? 'rgba(255, 255, 255, 0.2)' : 'transparent')};
  border-radius: 1200px;
  border: none;
  //padding: 8px; /* optional for bigger click target */
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #005fcc; /* highly visible blue outline */
    outline-offset: 2px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1); /* subtle hover effect */
  }

  &:active {
    background: rgba(255, 255, 255, 0.3); /* optional active feedback */
  }
`;

export const Cards = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MeetingDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-height: 200px;
  box-shadow: 0 4px 4px 0 #00134314;
  border: 1px solid #e6e5ec;
  border-radius: 16px;
  padding: 20px 24px;
  position: relative;
  overflow: hidden;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.blue['950']};
  margin-bottom: 8px;
`;

export const MeetingDate = styled.div<{ $state: 'ongoing' | 'notStarted' | 'expired' }>`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;

  div {
    background: ${colors.blue['100']};
    color: ${colors.blue['950']};
    font-size: 15px;
    font-weight: 500;
    padding: 4px 12px;
    border-radius: 100px;
    ${({ $state }) => $state === 'expired' && `text-decoration: line-through; color:${colors.grey['500']}`}
  }
`;

export const Description = styled.div<{ $state: 'ongoing' | 'notStarted' | 'expired' }>`
  color: ${colors.blue['950']};
  font-size: 16px;

  font-weight: 500;

  margin-bottom: 12px;
  border-radius: 8px;

  display: flex;
  gap: 8px;
  ${({ $state }) => $state === 'expired' && `background: ${colors.red['200']};`}
  ${({ $state }) => $state === 'ongoing' && `max-width: 230px;`}
  ${({ $state }) => $state === 'notStarted' && `background: ${colors.yellow['200']};max-width: 230px;`};

  @media (max-width: 480px) {
    ${({ $state }) =>
      $state === 'notStarted' &&
      `
    max-width: unset`}
  }
  padding: 8px;

  svg {
    position: unset;
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    span:first-of-type {
      font-size: 16px;
      line-height: 24px;
    }
    span:last-of-type {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const JoinMeeting = styled.button<{ $state: 'ongoing' | 'notStarted' | 'expired' }>`
  max-width: 163px;
  background: ${colors.blue['500']};
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border-radius: 100px;
  cursor: pointer;
  transition: 0.15s all ease-in-out;
  font-size: 14px;
  border: 2px solid white;
  outline: 1px solid white;

  &:focus-visible {
    border: 2px solid white;
    outline: 2px solid ${colors.blue['500']};
  }

  ${({ $state }) =>
    ($state === 'expired' || $state === 'notStarted') &&
    `
       background: ${colors.grey['300']};
       pointer-events: none;
    `}

  &:hover {
    background: ${colors.blue['600']};
  }

  @media (max-width: 480px) {
    max-width: unset;
  }
`;

export const YourDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 130px;
  max-height: 130px;
  background: #f7f6fa;
  border-radius: 16px;
  padding: 20px 24px;
  gap: 10px;
`;

export const DetailsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: ${colors.grey['500']};
  white-space: nowrap;

  span {
    margin-left: 16px;
    font-size: 16px;
    color: ${colors.blue['950']};
    word-break: break-all;
    white-space: wrap;
  }
`;

export const Name = styled(DetailsRow)``;
export const Email = styled(DetailsRow)``;
export const Phone = styled(DetailsRow)``;
